import { TaskCategory } from "models";

export const TASK_CATEGORY_TRANSLATION = {
  [TaskCategory.IMPLEMENTATION]: "INSTALACIÓN",
  [TaskCategory.SUPPORT]: "SOPORTE",
  [TaskCategory.MAINTENANCE]: "MANTENIMIENTO",
  [TaskCategory.SHIPMENT]: "ENVÍO",
};
